const editPictures = {
  en: {
    translation: {
      cover_image: "Cover image",
      cover_image_description:
        "Make the most of your business! Add a great cover photo to enhance your strong points",
      select_image: "Select image",
      location_image: "Ambience and location photos",
      location_image_description:
        "Choose the best pictures to describe the inside and the outside of your business",
      no_photos_yet: "There are no photos yet, add one!",
      dish_image: "Food & dish photos",
      dish_image_description:
        "Tempt your foodies! Add tasty photos of your dished and preparations.",
      foodies_images: "Photos from your foodies",
      no_foodies_images:
        "There are no photos yet! When your foodies will add pictures, they will appear here",
      filters_description:
        "Don't use too many filters as they might not be appetizing",
      no_blur: "Be careful! Don't upload blurry pics",
      no_people:
        "Add photo showing your business and don't use pictures with people",
      file_too_big_title: "File too big",
      file_too_big_text:
        "File is too big, please upload a photo of 2MB or less",
      picture_added_by: "Picture added by ",
      not_appropriate: "It's inappropriate",
      duplicate: "Duplicate",
      bad_content: "It's abusive or harmful",
      privacy: "It's a violation of privacy",
      blur: "Blur/bad quality",
      signal_success_title: "Request succeded",
      signal_success_text: "We got your request, wait for us to validate it",
      signal_failed_title: "Request failed",
      signal_failed_text: "Ops, something went wrong! Please try again later",
      service_not_paid_title: "Manage photos",
      service_not_paid_text:
        "Manage the photos of your business with our plans! Discover all the services included in the 'Essential, Essential plus and Premium' plans in the dedicated area.",
      service_not_paid_accept: "View our plans",
      show_all: "Show all ",
      update_image_button: "Upload image",
      images: " photos",
      logo: "Logo",
      logo_description:
        "Add your logo to help your customers recognize your brand",
      delete_logo: "Delete image"
    }
  },
  it: {
    translation: {
      cover_image: "Immagine di copertina",
      cover_image_description:
        "Arricchisci la tua scheda ristorante con l'immagine di copertina più adatta alla tua attività",
      select_image: "Seleziona immagine",
      location_image: "Aggiungi foto della location",
      location_image_description:
        "Scegli le foto che valorizzano la tua location e aggiungile qui.",
      no_photos_yet: "Non ci sono foto da mostrare, aggiungile!",
      dish_image: "Aggiungi foto dei piatti",
      dish_image_description:
        "Tenta i tuoi foodies! Aggiungi le foto delle tue ricette più appetitose.",
      foodies_images: "Foto dei foodie",
      no_foodies_images:
        "Non ci sono ancora foto, quando i tuoi foodies caricheranno degli scatti compariranno qui",
      filters_description:
        "Non esagerare con i filtri perché potrebbero non essere appetitosi",
      no_blur: "Fai attenzione a non inserire foto sfocate o mosse",
      no_people: "Fai foto alla location non alle persone",
      file_too_big_title: "File troppo grande",
      file_too_big_text:
        "Il file è troppo grande, per favore, carica una foto di 2MB o meno",
      picture_added_by: "Foto aggiunta da ",
      not_appropriate: "Non è appropriata",
      duplicate: "Duplicato",
      bad_content: "Contiene materiale offensivo, dannoso o osceno",
      privacy: "Viola la privacy",
      blur: "Sfocato/bassa qualità",
      signal_success_title: "Richiesta inviata con successo",
      signal_success_text:
        "Abbiamo ricevuto la tua richiesta, aspetta fino a che il nostro team la validerà",
      signal_failed_title: "Richiesta fallita",
      signal_failed_text:
        "Ops, qualcosa è andato storto! Per favore, riprova più tardi",
      service_not_paid_title: "Gestione foto",
      service_not_paid_text:
        "La gestione completa delle foto è inclusa nei pacchetti 'Essential, Essential plus e Premium'. Scopri i nostri servizi nella sezione dedicata.",
      service_not_paid_accept: "Scopri servizi",
      show_all: "Mostra altre ",
      update_image_button: "Aggiorna immagine",
      images: " foto",
      logo: "Logo",
      logo_description:
        "Aggiungi il tuo logo per farti riconoscere dai tuoi clienti in un colpo d'occhio",
      delete_logo: "Elimina immagine"
    }
  }
};

export default editPictures;
